import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import Reveal from "@/components/anim/Reveal";

const ProcessSection = () => {
  const { t } = useLang();

  return (
    <section className="bg-white section-y border-t border-brand-border" data-testid="process-section">
      <div className="container-x">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline">{t.process.eyebrow}</p>
          <h2 className="mt-4 font-heading font-bold text-brand-ink text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            {t.process.title}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-border border border-brand-border">
          {t.process.steps.map((step, i) => (
            <Reveal key={i} delay={i * 100}>
              <div
                className="bg-white p-8 sm:p-10 group hover:bg-brand-surface transition-colors duration-500 h-full relative overflow-hidden"
                data-testid={`process-step-${i}`}
              >
                <span className="absolute -bottom-4 -right-4 font-heading text-[120px] font-black leading-none text-brand-deep/5 group-hover:text-brand-deep/10 transition-colors duration-500 pointer-events-none select-none">
                  {step.n}
                </span>
                <p className="font-mono text-xs tracking-[0.25em] text-brand-deep relative">{step.n}</p>
                <h3 className="mt-4 font-heading text-xl sm:text-2xl font-bold text-brand-ink tracking-tight transition-colors duration-300 group-hover:text-brand-deep relative">
                  {step.t}
                </h3>
                <p className="mt-4 text-sm text-brand-muted leading-relaxed relative">{step.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
